<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      {{ title }}
    </div>
    <div v-loading="loading">
      <el-form
        ref="declutterReportForm"
        label-position="top"
        :model="declutterReport"
        :rules="rules"
      >
        <el-row :gutter="20" v-if="declutterReportId">
          <el-col :span="12">
            <el-form-item
              label="Év"
              prop="year"
            >
              <el-input
                v-model="declutterReport.year"
                style="width: 100%"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Sorszám"
              prop="number"
            >
              <el-input
                v-model="declutterReport.number"
                style="width: 100%"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="receipts"
              label="Bizonylatok"
            >
              <el-date-picker
                v-model="declutterReport.filtered_date"
                style="width: 100%;"
                type="month"
                value-format="yyyy-MM"
                :clearable="false"
                :disabled="declutterReport.status !== 'recorded' || type === 'view'"
                placeholder="Válasszon évet és hónapot..."
                @change="fetchItemsByMonth"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="delivery_date"
              label="Kiállítás dátuma"
            >
              <el-date-picker
                v-model="declutterReport.delivery_date"
                type="date"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="deliveryDateOption"
                :disabled="declutterReport.status !== 'recorded' || type === 'view'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="company_name"
              label="Cégnév"
            >
              <el-input
                readonly
                v-model="declutterReport.company_name"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="postal_code"
              label="Irányítószám"
            >
              <el-input
                readonly
                v-model="declutterReport.postal_code"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="city"
              label="Település"
            >
              <el-input
                readonly
                v-model="declutterReport.city"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="address"
              label="Cím"
            >
              <el-input
                readonly
                v-model="declutterReport.address"
                :disabled="type === 'view'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="contributors"
              label="Résztvevők a selejtezési bizottság részéről"
            >
              <p-table
                ref="contributors"
                :key="itemsTableKey + 'c'"
                :opts="{
                  addItem: true,
                  updateItem: true,
                  deleteItem: true,
                  editableFields: [],
                }"
                dialog="PersonDialog"
                :columns="[
                  {
                    label: 'Név',
                    prop: 'name',
                    minWidth: 100,
                  },
                  {
                    label: 'Beosztás',
                    prop: 'role',
                  },
                ]"
                :data="declutterReport.contributors"
                :empty-line="{
                  name: '',
                  role: '',
                }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="supervision_contributors"
              label="Résztvevők a felügyeleti (érdekképviseleti) szerv részéről"
            >
              <p-table
                ref="supervisionContributors"
                :key="itemsTableKey + 'sc'"
                :opts="{
                  addItem: true,
                  updateItem: true,
                  deleteItem: true,
                  editableFields: [],
                }"
                dialog="PersonDialog"
                :columns="[
                  {
                    label: 'Név',
                    prop: 'name',
                    minWidth: 100,
                  },
                  {
                    label: 'Beosztás',
                    prop: 'role',
                  },
                ]"
                :data="declutterReport.supervision_contributors"
                :empty-line="{
                  name: '',
                  role: '',
                }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="task_contributors"
              label="Szükséges intézkedésekért felelős dolgozó(k) kijelölése"
            >
              <p-table
                ref="taskContributors"
                :key="itemsTableKey + 'tc'"
                :opts="{
                  addItem: true,
                  updateItem: true,
                  deleteItem: true,
                  editableFields: [],
                }"
                dialog="PersonTaskDialog"
                :columns="[
                  {
                    label: 'Intézkedés',
                    prop: 'task',
                    minWidth: 100,
                  },
                  {
                    label: 'Név',
                    prop: 'name',
                    minWidth: 100,
                  },
                  {
                    label: 'Beosztás',
                    prop: 'role',
                  },
                ]"
                :data="declutterReport.task_contributors"
                :empty-line="{
                  task: '',
                  name: '',
                  role: '',
                }"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          prop="comment"
          label="Gondatlanság vagy egyéb mulasztás miatti megállapítások és javaslatok"
        >
          <el-input
            v-model="declutterReport.comment"
            type="textarea"
            :rows="3"
            :disabled="type === 'view'"
          />
        </el-form-item>
        <el-form-item
          prop="items"
          label="Tételek"
        >
          <p-table
            ref="items"
            :key="itemsTableKey"
            :opts="{
              addItem: false,
              updateItem: true,
              deleteItem: true,
              editableFields: [],
            }"
            @change="updateReceipts"
            dialog="PriceDialog"
            :columns="[
              {
                label: 'Selejtezés',
                prop: 'declutter_receipt_number',
                minWidth: 100,
              },
              {
                label: 'Beszállító',
                prop: 'supplier_name',
                minWidth: 100,
              },
              {
                label: 'Termék',
                prop: 'name',
                minWidth: 100,
              },
              {
                label: 'Selejtezés oka',
                prop: 'declutter_reason',
              },
              {
                label: 'Mennyiség',
                prop: 'count',
                minWidth: 100,
              },
              {
                label: 'Db / kiszerelés',
                prop: 'count_per_pack',
              },
              {
                label: 'Kiszerelés',
                prop: 'pack_type_name',
              },
              {
                label: 'Egységár',
                prop: 'unit_price',
              },
              {
                label: 'Nettó ár',
                prop: 'net_price',
              },
            ]"
            :data="declutterReport.items"
            :empty-line="{
              task: '',
              name: '',
              role: '',
            }"
          />
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="type !== 'view'"
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :loading="buttonLoading"
        :disabled="declutterReport.status !== 'recorded'"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import PTable from '../../../utils/PTable/index';

  export default {
    components: {
      PTable,
    },
    props: ['type', 'declutterReportId'],
    data() {
      return {
        loading: false,
        itemsTableKey: 1,
        buttonLoading: false,
        products: null,
        declutters: [],
        fetchedReceipts: [],
        declutterReport: {
          year: null,
          number: null,
          company_name: this.$config('DECLUTTER_COMPANY_NAME'),
          postal_code: this.$config('DECLUTTER_COMPANY_POSTAL_CODE'),
          city: this.$config('DECLUTTER_COMPANY_CITY'),
          address: this.$config('DECLUTTER_COMPANY_ADDRESS'),
          delivery_date: '',
          receipts: [],
          items: [],
          contributors: [],
          supervision_contributors: [],
          task_contributors: [],
          status: 'recorded',
          filtered_date: ''
        },
        rules: {
          year: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          number: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          company_name: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
          postal_code: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
          city: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
          address: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
          delivery_date: [
            {
              required: true,
              message: 'Érték megadása kötelező',
              trigger: 'change'
            }
          ],
        },
        deliveryDateOption: {
          firstDayOfWeek: 1,
          disabledDate: (date) => {
            return moment(date).format('YYYY-MM') < moment(this.declutterReport['filtered_date']).startOf('month').format('YYYY-MM');
          }
        }
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új selejtezés';
        } else if (this.type === 'update') {
          return 'Selejtezés módosítása';
        } else if (this.type === 'view') {
          return 'Selejtezés megtekintése';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
      enabledElements() {
        if (this.type === 'view') {
          return [];
        }
        switch (this.declutterReport.status) {
          case 'recorded':
            return ['addButton', 'deleteButton', 'product', 'pack', 'count', 'vat', 'expirationDateSelector', 'declutterReportReason', 'supplierSelector', 'comment'];
          case 'completed':
            return [];
          case 'cancelled':
            return [];
          default:
            return [];
        }
      },
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      storages() {
        return this.$store.getters['storage/storages'];
      },
      currencies() {
        return this.$store.getters['currency/currencies'];
      }
    },
    async mounted() {
      this.loading = true;
      this.declutters = await axios.get('api/declutters/reports');
      if (this.declutterReportId) {
        this.declutterReport = await this.$store.dispatch('declutterReport/fetch', this.declutterReportId);
        this.declutterReport.receipts = this.declutterReport.declutters.map(d => d.id);
        this.declutters = [
          ...this.declutters,
          ...this.declutterReport.declutters.map(d => ({id: d.id, receipt_number: d.receipt_number}))
        ];
        this.fetchedReceipts = this.declutterReport.receipts;
        this.itemsTableKey++;
      }
      this.loading = false;
    },
    methods: {
      async fetchItems(ids) {
        const selectedIds = ids.filter(id => !this.fetchedReceipts.find(i => i === id))
        const removeIds = this.fetchedReceipts.filter(id => !ids.find(i => i === id))
        if (selectedIds.length) {
          const id = selectedIds[0]
          const items = await axios.get(`api/declutters/items/${id}`);
          this.declutterReport.items = [
            ...this.declutterReport.items,
            ...items
          ]
        }
        if (removeIds.length) {
          const id = removeIds[0]
          this.declutterReport.items = this.declutterReport.items.filter(item => item.declutter_id !== id)
        }
        this.itemsTableKey++;
        this.fetchedReceipts = ids;
      },
      async fetchItemsByMonth() {
        this.declutterReport.items = [];
        this.declutterReport.receipts = [];
        this.fetchedReceipts = [];

        const items = await axios.get(`api/declutters/items-by-month/${this.declutterReport.filtered_date}`);
        const declutterIds = items.map(item => item.declutter_id).filter((value, index, self) => self.indexOf(value) === index);

        this.declutterReport.items = [
          ...this.declutterReport.items,
          ...items
        ];

        this.itemsTableKey++;
        this.fetchedReceipts = declutterIds;
        this.declutterReport.receipts = declutterIds;
      },
      handleClose() {
        if (this.type === 'view') {
          return this.$router.replace('/processes/declutters/reports');
        }
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/processes/declutters/reports');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs.declutterReportForm.validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            this.declutterReport.items = this.$refs.items.getItems()
            this.declutterReport.contributors = this.$refs.contributors.getItems()
            this.declutterReport.supervision_contributors = this.$refs.supervisionContributors.getItems()
            this.declutterReport.task_contributors = this.$refs.taskContributors.getItems()
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('declutterReport/create', this.declutterReport);
              } else if (this.type === 'update') {
                await this.$store.dispatch('declutterReport/update', this.declutterReport);
              }
              this.$store.dispatch('declutterReport/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/processes/declutters/reports');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
      getStatus() {
        switch (this.declutterReport.status) {
          case 'recorded':
            return {
              label: 'Rögzítve',
              tag: 'info',
            };
          case 'cancelled':
            return {
              label: 'Érvénytelenítve',
              tag: 'danger',
            };
          case 'completed':
            return {
              label: 'Teljesített',
              tag: 'success',
            };
        }
      },
      openReceipt() {
        if (this.declutterReport.receipt_file && this.declutterReport.receipt_file.path) {
          window.open(this.declutterReport.receipt_file.path);
        }
      },
      updateReceipts() {
        this.declutterReport.receipts = this.$refs.items.getItems()
          .map(d => d.declutter_id)
          .filter((value, index, self) => self.indexOf(value) === index);
      }
    },
  };
</script>

<style lang="scss">
  .price-sum {
    margin-top: 20px;
    text-align: right;
    font-size: 18px;

    > div {
      display: inline-block;
    }
  }
</style>
